/**
 * @generated SignedSource<<467df260b1e7812364886fedb6d4a6ee>>
 * @relayHash a5c3ab34fee6e976f943ae49e1ab9574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5d9150d3bc0c8fa720864e5de499cc3f506b815b187b51b727e0e85f1112a286

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type cascadingSelect_cascadingSelectSearchQuery$variables = {
  id: string;
};
export type cascadingSelect_cascadingSelectSearchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment">;
};
export type cascadingSelect_cascadingSelectSearchQuery = {
  response: cascadingSelect_cascadingSelectSearchQuery$data;
  variables: cascadingSelect_cascadingSelectSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "kind": "ScalarField",
    "name": "optionId"
  },
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "cascadingSelect_cascadingSelectSearchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cascadingSelect_cascadingSelectSearchQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraCascadingOptionsConnection",
                "kind": "LinkedField",
                "name": "cascadingOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCascadingOptionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraCascadingOptions",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "parentOptionValue",
                            "plural": false,
                            "selections": (v5/*: any*/)
                          },
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "childOptionValues",
                            "plural": true,
                            "selections": (v5/*: any*/)
                          },
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ],
                "storageKey": "cascadingOptions(first:1000)"
              },
              {
                "args": (v3/*: any*/),
                "handle": "connection",
                "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_cascadingOptions",
                "kind": "LinkedHandle",
                "name": "cascadingOptions"
              }
            ],
            "type": "JiraCascadingSelectField"
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "5d9150d3bc0c8fa720864e5de499cc3f506b815b187b51b727e0e85f1112a286",
    "metadata": {},
    "name": "cascadingSelect_cascadingSelectSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "13909fd597ca783ac3c98bb61f08915d";

export default node;
